var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "contents-bottom-md-none",
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function () {
        return [_c('sub-visual-primary', {
          attrs: {
            "tit": "마이페이지",
            "bg": "/images/mypage/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "path",
            fn: function () {
              return [_c('v-breadcrumbs', {
                attrs: {
                  "items": _vm.breadcrumbsItems
                },
                scopedSlots: _vm._u([{
                  key: "divider",
                  fn: function () {
                    return [_c('v-icon', {
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-chevron-right")])];
                  },
                  proxy: true
                }])
              })];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('mypage-layout', [_c('v-tabs-items', {
    attrs: {
      "value": _vm.tab,
      "touchless": ""
    }
  }, [_c('myinfo-tab-verify', {
    on: {
      "next": function ($event) {
        _vm.tab = 'modify';
      }
    }
  }), _c('v-tab-item', {
    attrs: {
      "value": "modify"
    }
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('div', {
    staticClass: "tit tit--xxs"
  }, [_vm._v("회원정보 수정")])]), !_vm.hasCompanyScope ? _c('myinfo-person-form', _vm._b({
    on: {
      "input": _vm.save,
      "cancel": function ($event) {
        _vm.tab = 'verify';
      }
    }
  }, 'myinfo-person-form', {
    value: _vm.form,
    loading: _vm.loading
  }, false)) : _c('myinfo-company-form', _vm._b({
    on: {
      "input": _vm.save,
      "cancel": function ($event) {
        _vm.tab = 'verify';
      }
    }
  }, 'myinfo-company-form', {
    value: _vm.form,
    loading: _vm.loading
  }, false))], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }